<template>
  <div class="sunstudy-controls">
    <v-btn
      v-if="sunstudyAvailable && !sunstudyMode"
      fab
      class="sunstudy-switcher"
      :color="sunstudyMode ? 'primary' : undefined"
      @click="toggleSunstudyMode"
    >
      <Sunrise />
    </v-btn>

    <template v-if="sunstudyMode">
      <div v-if="sunstudyStandardMode" class="sunstudy-standard">
        <v-btn-toggle
          v-if="sunstudySeasons.length > 1"
          v-model="season"
          class="seasons"
          mandatory
          borderless
        >
          <v-btn
            v-for="season in sunstudySeasons"
            :key="season.id"
            :ripple="false"
            x-small
            style="color: white"
          >
            {{ $t(season.key) }}
          </v-btn>
        </v-btn-toggle>
        <img
          :src="imageUrl('img/marzipano/minimap-close.svg')"
          class="close-sunstudy"
          @click="toggleSunstudyMode"
        />
      </div>
      <div v-else class="sunstudy-timeline">
        <div class="mobile-ticker">
          <v-icon style="color: white"> {{ 'mdi-clock-outline' }}</v-icon>
          <span>{{tick}}</span>
        </div>
        <v-slider
          v-model="position"
          :min="0"
          :max="ticks.length ? ticks.length - 1 : 0"
          color="white"
          track-color="white"
          :thumb-color="thumbColor"
          step="0"
          thumb-label="always"
          @change="setSunstudyPosition($event)"
        >
          <template v-slot:thumb-label="{ value }">
            {{ tick }}
          </template>
          <template v-slot:prepend>
            <v-icon @click="toggleSunstudyAutoplay">
              {{ sunstudyAutoplay ? 'mdi-pause' : 'mdi-play' }}
            </v-icon>
            <transition name="fade">
              <div class="tick start" v-show="showMinTick">
                {{ minTick }}
              </div>
            </transition>
          </template>
          <template v-slot:append>
            <transition name="fade">
              <div class="tick end" v-show="showMaxTick">
                {{ maxTick }}
              </div>
            </transition>
          </template>
        </v-slider>
        <img
          :src="imageUrl('img/marzipano/minimap-close.svg')"
          class="close-sunstudy"
          @click="toggleSunstudyMode"
        />
        <v-btn-toggle
          v-if="sunstudySeasons.length > 1"
          v-model="season"
          class="seasons"
          mandatory
          borderless
        >
          <v-btn
            v-for="season in sunstudySeasons"
            :key="season.id"
            :ripple="false"
            x-small
            style="color: white"
          >
            {{ $t(season.key) }}
          </v-btn>
        </v-btn-toggle>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Sunrise from "@/components/icons/Sunrise.vue";
import { imageUrl } from '@/utils/urls';

export default {
  name: 'SunstudyControls',
  components: {
    Sunrise,
  },
  computed: {
    ...mapGetters('sunstudy', [
      'sunstudyAvailable',
      'sunstudyMode',
      'sunstudy',
      'sunstudyPosition',
      'sunstudyAutoplay',
      'sunstudySeasons',
      'seasonPosition',
    ]),
    ...mapGetters('service', ['primaryColor']),
    thumbColor() {
      return this.primaryColor? this.primaryColor : '#577189'
    },
    sunstudyStandardMode() {
      return this.sunstudy.default
    },
    season: {
      get() {
        return this.seasonPosition;
      },
      set(value) {
        this.setSeason(value);
      },
    },
    ticks() {
      return this.sunstudy.images.map(image => image.time);
    },
    tick() {
      const { [this.position]: { time } = {} } = this.sunstudy.images;
      return time;
    },
    minTick() {
      const { time } = this.sunstudy.images[0] || {};
      return time;
    },
    showMinTick() {
      return this.position > 2
    },
    maxTick() {
      const { [this.sunstudy.images.length - 1]: { time } = {} } = this.sunstudy.images;
      return time;
    },
    position: {
      get() {
        return this.sunstudyPosition;
      },
      set(value) {
        this.setSunstudyPosition(value);
      },
    },
    showMaxTick() {
      return this.position < this.sunstudy.images.length - 4
    },
  },
  methods: {
    imageUrl,
    ...mapActions('sunstudy', ['toggleSunstudyAutoplay', 'setSunstudyPosition', 'toggleSunstudyMode']),
    ...mapMutations('sunstudy', ['setSeason']),
  },
};
</script>

<style scoped lang="scss">
.sunstudy-controls {
  // the container is hidden
  position: absolute;
  width: 0;
  height: 0;
  top: -1px;
}

.sunstudy-switcher {
  position: fixed;
  top: 71px;
  left: 50%;
  transform: translateX(-50%);
  transition: transform 0.3s ease;

  @media (max-width: 1500px), (max-height: 920px) {
    transform: translate(-50%) scale(0.85);  }
}

.sunstudy-standard {
  border: none;
  border-radius: 5px;
  position: fixed;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(2px 2px 5px #444);
  background-color: rgba(0,0,0,.55);
  ::v-deep .v-btn-toggle {
    background: none;
  }
  .seasons {
    button {
      text-transform: initial !important;
      border: none !important;
      font-size: 0.8rem !important;
      transition: .2s;
      height: 35px;
      padding: 7px 20px;
      @media screen and (max-width: 550px) {
        padding: 7px 12px;
      }
      &:focus {
        outline: none;
      }
      &:active {
        outline: none;
      }
    }
    .v-btn--active {
      background-color: #353535 !important;
    }
  }
  .close-sunstudy {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 26px;
  }
  ::v-deep .v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background: none;
  }
}
.sunstudy-timeline {
  background-color: rgba(0,0,0,.55);
  border-radius: 5px;
  border: none;
  filter: drop-shadow(2px 4px 5px #444);
  padding: 30px 20px 0;
  position: fixed;
  top: 70px;
  width: 35%;
  left: 50%;
  transform: translateX(-50%);
  & .mobile-ticker {
    display: none;
  }
  @media screen and (max-width: 550px) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
    width: 150px;
    height: 56px;
    gap: 8px;
    padding: 4px 0;
    & .seasons {
      bottom: -25px;
    }
    ::v-deep .v-input {
      flex: inherit;
    }
    ::v-deep .v-input__prepend-outer {
      margin: 0;
    }
    ::v-deep .v-input__append-outer {
      margin: 0;
    }
    ::v-deep .v-input__control {
      display: none;
    }
    ::v-deep .v-input {
      justify-content: center;
    }
    .mobile-ticker {
      text-align: center;
      font-size: 1rem;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1px;
      & i {
        color: white;
        font-size: 1rem;
      }
    }
  }

  & ::v-deep i.v-icon.v-icon--link {
    color: white;
  }

  ::v-deep .v-slider--horizontal .v-slider__thumb-label {
    left: 6px;
    background: transparent !important;
    border-color: transparent !important;
    transform: translateX(-50%) translateY(-12px) !important;

    & > * {
      color: white;
      font-weight: 500;
      transform: none;
    }
  }
  ::v-deep .v-slider__thumb {
    width: 24px;
    height: 24px;
    border: 2px solid #eee !important;
    cursor: pointer;
    &:before {
      width: 0;
      height: 0;
    }
  }
  ::v-deep .v-input__control .v-messages {
    display: none;
  }
  ::v-deep .v-input__slot {
    margin-bottom: 10px;
  }

  ::v-deep .tick {
    position: absolute;
    top: 0;
    transform: translateY(13px) translateX(var(--v-slider-tick-correction));
    color: white;
    font-size: 12px;

    @media screen and (max-width: 550px) {
      display: none;
    }
    &.start {
      --v-slider-tick-correction: -50%;
      left: 60px;
    }

    &.end {
      --v-slider-tick-correction: 50%;
      right: 60px;
    }
  }
  .close-sunstudy {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 26px;
  }

  .seasons {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    button {
      text-transform: initial !important;
      background-color: #070707 !important;
      border: none !important;
      font-size: 0.8rem !important;
      transition: .2s;
      height: 25px;
      &:focus {
        outline: none;
      }
      &:active {
        outline: none;
      }
    }
    .v-btn--active {
      background-color: #353535 !important;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>

<style lang="scss">
i.v-icon.notranslate.v-icon--link.mdi.mdi-play.theme--light {
  color: white;
}
</style>
